import { render, staticRenderFns } from "./BbeeContactosC.vue?vue&type=template&id=aa9d5456"
import script from "./BbeeContactosC.vue?vue&type=script&lang=js"
export * from "./BbeeContactosC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports